import React, { useCallback, useContext, useEffect } from 'react';
import { Box, Typography, Container, Card, Tabs, Tab, Grid, Divider } from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';

const { PRIVATE_ROUTE } = API_ROUTES;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const StaffTaskView = () => {
  const { id } = useParams();
  const [valueOne, setValueOne] = React.useState(0);
  const [valueTwo, setValueTwo] = React.useState(0);
  const { authAxios } = useContext(FetchContext);
  const [taskData, setTaskData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const handleChangeone = (event, newValue) => {
    setValueOne(newValue);
  };
  const handleChangetwo = (event, newValue) => {
    setValueTwo(newValue);
  };

  const getTaskData = useCallback(async () => {
    const { data } = await authAxios.get(`${PRIVATE_ROUTE.GET_TASK_BY_ID}/${id}`);
    setTaskData(data?.data[0]);
    setLoading(false);
  }, [authAxios, id]);

  useEffect(() => {
    getTaskData();
  }, []);

  return (
    <>
      <Container maxWidth="xl">
        <Typography variant="h4" component="h2">
          Task View
        </Typography>
        <Box marginTop={'30px'}>
          <Grid container>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Task No.:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {taskData?.number_str}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Job No.:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {taskData?.job_id?.number_str}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Client No.:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {taskData?.client_id?.number_str}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Client Address:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {taskData?.client_address}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Status:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {taskData?.status_id?.name}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Office:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {taskData?.office_id?.name}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                DWR Billing Type:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {'Time & Materials'}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Taks Category:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {taskData?.task_category_id?.name}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Task Scope:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {taskData?.task_scope_id?.name}
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
              <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                Scope Details:
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
              <Typography variant="body1" color="initial">
                {''}
              </Typography>
            </Grid>
          </Grid>
          <Typography mt={'30px'} variant="h6" color="initial">
            Additional Details
          </Typography>
          <Card style={{ marginTop: '30px' }}>
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={valueOne} onChange={handleChangeone} aria-label="basic tabs example">
                  <Tab label="Locations" {...a11yProps(0)} />
                  <Tab label="Contacts" {...a11yProps(1)} />
                  <Tab label="Additional Fields" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <TabPanel value={valueOne} index={0}>
                <Typography mb={'5px'} variant="h6" color="initial">
                  Locations
                </Typography>
                {taskData?.client_locations?.map((item) => (
                  <>
                    <Grid sx={{ marginLeft: 6 }} container>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Location Name:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.name}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Munciple Address:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.munciple_address}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          State / Province:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.state}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          City:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.city}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Postal Code:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={10} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.postal_code}
                        </Typography>
                      </Grid>
                    </Grid>
                    {taskData.client_locations.length > 1 && <Divider sx={{ marginBlock: 3 }} />}
                  </>
                ))}
              </TabPanel>
              <TabPanel value={valueOne} index={1}>
                <Typography mb={'5px'} variant="h6" color="initial">
                  Contacts
                </Typography>
                {taskData?.client_contacts?.map((item) => (
                  <>
                    <Grid sx={{ marginLeft: 6 }} container>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Full Name:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item?.first_name + ' ' + item?.last_name}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Position:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          <a
                            style={{ color: 'black', textDecoration: 'none' }}
                            href={'https://elevatelandsurveying.com/'}
                          >
                            {item?.position}
                          </a>
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Depatrment:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item?.department}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Location:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          <a
                            style={{ color: 'black', textDecoration: 'none' }}
                            href={'https://elevatelandsurveying.com/'}
                          >
                            {item?.location}
                          </a>
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Email:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          <a style={{ color: 'black', textDecoration: 'none' }} href={'mailto:' + item?.email}>
                            {item?.email}
                          </a>
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Phone:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          <a style={{ color: 'black', textDecoration: 'none' }} href={'tel:+14578545214'}>
                            {item?.phone}
                          </a>
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Cell:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          <a style={{ color: 'black', textDecoration: 'none' }} href={''}>
                            {item?.cell}
                          </a>
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Notes:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item?.remark}
                        </Typography>
                      </Grid>
                    </Grid>
                    {[1].length > 1 && <Divider sx={{ marginBlock: 3 }} />}
                  </>
                ))}
              </TabPanel>
              <TabPanel value={valueOne} index={2}>
                <Typography mb={'5px'} variant="h6" color="initial">
                  Additional Fields
                </Typography>
                {[1].map((item) => (
                  <>
                    <Grid sx={{ marginLeft: 6 }} container>
                      <Grid sx={{ marginTop: '10px' }} md={2} sm={6} xs={6} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Additional Field Name:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={3} sm={6} xs={6} item>
                        <Typography variant="body1" color="initial">
                          {`Demo Field ${item}`}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={3} sm={6} xs={6} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Additional Field Value (Percentage):
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} sm={6} xs={6} item>
                        <Typography variant="body1" color="initial">
                          {'1%'}
                        </Typography>
                      </Grid>
                    </Grid>
                    {[1].length > 1 && <Divider sx={{ marginBlock: 3 }} />}
                  </>
                ))}
              </TabPanel>
            </Box>
          </Card>
          <Typography mt={'30px'} variant="h6" color="initial">
            Billable Line Items
          </Typography>
          <Card style={{ marginTop: '30px' }}>
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={valueTwo} onChange={handleChangetwo} aria-label="basic tabs example">
                  <Tab label="Labour Costs" {...a11yProps(0)} />
                  <Tab label="Equipment and Materials" {...a11yProps(1)} />
                  <Tab label="Fixed Price" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <TabPanel value={valueTwo} index={0}>
                <Typography mb={'5px'} variant="h6" color="initial">
                  Labour Costs
                </Typography>
                {taskData?.billing_line_items?.labour_item?.labour_cost_items?.map((item) => (
                  <>
                    <Grid sx={{ marginLeft: 6 }} container>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Cost Item:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.costItem}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Name:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.name}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Unit:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.unit}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Unit Cost:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.unitCost}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Budget Quantity:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.unitCost}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Hourly Cost:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.hourlyCost}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={6} xs={12} item>
                        <div style={{ display: 'flex' }}>
                          {item.text_exemptLabour ? (
                            <CheckBoxOutlinedIcon sx={{ marginRight: 2 }} />
                          ) : (
                            <CheckBoxOutlineBlankOutlinedIcon sx={{ marginRight: 2 }} />
                          )}
                          <Typography mb={'5px'} variant="h6" color="initial">
                            Tax Exempt
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                    {taskData?.billing_line_items?.labour_item?.labour_cost_items?.length > 1 && (
                      <Divider sx={{ marginBlock: 3 }} />
                    )}
                  </>
                ))}
              </TabPanel>
              <TabPanel value={valueTwo} index={1}>
                <Typography mb={'5px'} variant="h6" color="initial">
                  Other Cost Line Items (Incidentals, Equipment, Materials)
                </Typography>
                {taskData?.billing_line_items?.equipment_item?.equipment_cost_items?.map((item) => (
                  <>
                    <Grid sx={{ marginLeft: 6 }} container>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Cost Item:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.costItem}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Name:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.name}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Unit:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.unit}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Unit Cost:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.unitCost}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={6} xs={12} item>
                        <div style={{ display: 'flex' }}>
                          {item.text_exempt ? (
                            <CheckBoxOutlinedIcon sx={{ marginRight: 2 }} />
                          ) : (
                            <CheckBoxOutlineBlankOutlinedIcon sx={{ marginRight: 2 }} />
                          )}
                          <Typography mb={'5px'} variant="h6" color="initial">
                            Tax Exempt
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                    {taskData?.billing_line_items?.equipment_item?.equipment_cost_items?.length > 1 && (
                      <Divider sx={{ marginBlock: 3 }} />
                    )}
                  </>
                ))}
              </TabPanel>
              <TabPanel value={valueTwo} index={2}>
                <Typography mb={'5px'} variant="h6" color="initial">
                  Fixed Price Line Items
                </Typography>
                {taskData?.billing_line_items?.fixed_item?.map((item) => (
                  <>
                    <Grid sx={{ marginLeft: 6 }} container>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Cost Item:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.costItem}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Name:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.name}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Unit:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.unit}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={2} xs={5} item>
                        <Typography fontWeight={'bold'} variant="subtitle1" color="initial">
                          Unit Cost:
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={4} xs={7} item>
                        <Typography variant="body1" color="initial">
                          {item.unitCost}
                        </Typography>
                      </Grid>
                      <Grid sx={{ marginTop: '10px' }} md={6} xs={12} item>
                        <div style={{ display: 'flex' }}>
                          {item.text_exempt_Fix ? (
                            <CheckBoxOutlinedIcon sx={{ marginRight: 2 }} />
                          ) : (
                            <CheckBoxOutlineBlankOutlinedIcon sx={{ marginRight: 2 }} />
                          )}
                          <Typography mb={'5px'} variant="h6" color="initial">
                            Tax Exempt
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                    {taskData?.billing_line_items?.equipment_item?.equipment_cost_items?.length > 1 && (
                      <Divider sx={{ marginBlock: 3 }} />
                    )}
                  </>
                ))}
              </TabPanel>
            </Box>
          </Card>
          <div style={{ marginTop: '30px', display: 'flex' }}>
            {true ? (
              <CheckBoxOutlinedIcon sx={{ marginInline: 2 }} />
            ) : (
              <CheckBoxOutlineBlankOutlinedIcon sx={{ marginInline: 2 }} />
            )}
            <Typography mb={'5px'} variant="h6" color="initial">
              Active
            </Typography>
          </div>
        </Box>
      </Container>
    </>
  );
};

export default StaffTaskView;
